import axios from "axios";

const axiosClient = axios.create();

axiosClient.defaults.baseURL = process.env.REACT_APP_MTS_DOMAIN;

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  "x-api-key": process.env.REACT_APP_MTS_DOMAIN_API_KEY,
  Accept: "application/json",
};

axiosClient.defaults.timeout = 30000;

export default axiosClient;
